import React, { useState, useReducer, useEffect, useContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import axios from '../../../../../api/axios';
import { store as mainStore } from '../../../../../store';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Main from './Main';
import Categories from './Categories/Categories';
import Rules from './Rules/Rules';
import { store, initialState, reducer } from './reducer';

const Operators = () => {
  const [settings, setSettings] = useState(null);
  const { showMessage, showError } = useContext(mainStore);
  const [state, dispatch] = useReducer(reducer, initialState);
  const { title, subtitle } = state;
  const { Provider } = store;
  const { path } = useRouteMatch();

  const loadSettings = async () => {
    try {
      const { data } = await axios.get(`/api/v1/admin/settings/operators`);
      data?.ok && setSettings(data.settings);
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };
  const handleCheckBoxChanged = (e) => {
    const { checked, name } = e.target;
    setSettings({ ...settings, [name]: checked });
  };
  const saveSettings = async () => {
    try {
      await axios.put(`/api/v1/admin/settings`, {
        settings,
        section: 'driver',
      });
      showMessage('تنظیمات با موفقیت ذخیره شد.');
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };

  useEffect(() => {
    // loadSettings();
  }, []);

  return (
    <Provider value={{ state, dispatch, showMessage, showError }}>
      <FullCard title={title} category={subtitle}>
        <Switch>
          <Route exact path={path} children={<Main />} />
          <Route path={`${path}/categories`} children={<Categories />} />
          <Route path={`${path}/rules`} children={<Rules />} />
        </Switch>
      </FullCard>
    </Provider>
  );
};

export default Operators;
